import React from 'react';
import { Confirmation, Input, TextArea } from 'freemium-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type TemplateDescriptionFormType = {
  name?: string | null;
  desc?: string | null;
};

export type TemplateDescriptionFormProps = {
  isLoading?: boolean;
  onSubmit: (val: TemplateDescriptionFormType) => void;
  onDismiss: () => void;
  title: string;
  description?: string;
  confirmButtonText?: string;
};

export const TemplateDescriptionForm = ({
  isLoading,
  onSubmit,
  onDismiss,
  confirmButtonText,
  title,
  description,
}: TemplateDescriptionFormProps) => {
  const {
    handleSubmit,
    register,
    formState: { submitCount, errors },
  } = useFormContext<TemplateDescriptionFormType>();
  const { t } = useTranslation();
  return (
    <Confirmation
      width="540px"
      isOpen
      onDismiss={onDismiss}
      confirmButtonDisabled={isLoading}
      cancelButtonDisabled={isLoading}
      title={title}
      cancelButtonText={`${t('cancel')}`}
      confirmButtonText={confirmButtonText || `${t('save')}`}
      onConfirm={() => {
        handleSubmit(
          (val) => onSubmit(val),
          (err) => console.log('ERR', err),
        )();
      }}
    >
      <ConfirmationBody style={{ color: 'var(--base-color)' }}>
        {description && <ConfirmationDesc>{description}</ConfirmationDesc>}
        <Input
          {...register('name')}
          label={`${t('name')}`}
          inline
          isErrored={submitCount > 0 && Boolean(errors.name?.message)}
          errorText={
            submitCount > 0 && errors.name?.message ? errors.name.message : ''
          }
        />
        <TextArea
          {...register('desc')}
          label={`${t('description')}`}
          placeholder={`${t('settings.saved_templates.template_description')}`}
          isErrored={submitCount > 0 && Boolean(errors.desc?.message)}
          errorText={
            submitCount > 0 && errors.desc?.message ? errors.desc.message : ''
          }
        />
      </ConfirmationBody>
    </Confirmation>
  );
};

export default TemplateDescriptionForm;

export const ConfirmationDesc = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--secondary-color);
`;

export const ConfirmationBody = styled.div`
  & > :not(:last-child) {
    margin-bottom: 12px;
  }
  max-width: 512px;
  label {
    color: var(--color-elephant-900);
  }
`;
